import React from 'react';
import ExternalLinkIcon from 'ui/Icons/tabler/external-link.component.svg';
import FluidButton from 'ui/FluidButton';

interface IInvoicePreviewPanelProps {
  file: File | null;
  filePreviewUrl: string | null;
  onReplace: () => void;
}

export const InvoicePreviewPanel = ({ file, filePreviewUrl, onReplace }: IInvoicePreviewPanelProps) => {
  const hasFile = file && filePreviewUrl;

  return (
    <div className="sticky top-[20px] bg-gray-20 p-[20px] flex flex-col gap-[10px]">
      {hasFile && (
        <div className="flex items-center justify-between">
          <a
            href={filePreviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-pt-sans text-[16px] text-brown-prime underline cursor-pointer flex items-center gap-[5px] min-w-0"
            title={file.name}
          >
            <span className="truncate">{file.name}</span>
            <ExternalLinkIcon className="w-[20px] h-[20px] shrink-0 overflow-visible" />
          </a>
          <FluidButton type="secondary" onClick={onReplace}>
            Replace File
          </FluidButton>
        </div>
      )}

      <div className="aspect-[1/1.4142] border border-solid border-gray-20 bg-white-hard flex items-center justify-center">
        {hasFile ? (
          <iframe src={`${filePreviewUrl}#toolbar=0`} className="w-full h-full border-0" title="Invoice preview" />
        ) : (
          <span className="font-pt-sans text-[15px] text-gray-100 italic">PDF Preview not generated yet.</span>
        )}
      </div>
    </div>
  );
};
